import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

class Home extends React.Component {

  do() {
    this.props.history.replace(`/dashboard`)
  }

  componentDidMount() {
    this.do()
  }

  componentDidUpdate() {
    this.do()
  }

  render = () => null

}

export default connect(
  (store, props) => ({
  }),
)(Home)




// WEBPACK FOOTER //
// ./src/containers/home/index.js